export const filterAssignmentsByType = type => ({ assignmentType }) => assignmentType === type;
